import { SmartLink } from './SmartLink'
import type { LinkTarget } from './types'

export interface ProjectCardProps extends LinkTarget {
  image: string
  title: string
  descr: string
  /** `sm` adds the `ul-project--sm` modifier used by the narrower grid cells. */
  size?: 'default' | 'sm'
}

/**
 * A `.ul-project` card. Shared by the `projects` listing (6 cards) and the home
 * page's projects grid (4 cards) — identical markup, only the size modifier varies
 * with the column width it sits in.
 *
 * The target comes from `LinkTarget`, so a card can point at an in-app route (`to`) or at
 * another KKF app (`href`). On the Foundation site three of its four cards do the latter:
 * that grid is where the entry point hands a visitor on to a venture.
 */
export function ProjectCard({ image, title, descr, to, href, size = 'default' }: ProjectCardProps) {
  return (
    <div className={size === 'sm' ? 'ul-project ul-project--sm' : 'ul-project'}>
      <div className="ul-project-img">
        <img src={image} alt="Project Image" />
      </div>
      <div className="ul-project-txt">
        <div>
          <h3 className="ul-project-title">
            <SmartLink to={to} href={href}>
              {title}
            </SmartLink>
          </h3>
          <p className="ul-project-descr">{descr}</p>
        </div>
        <SmartLink to={to} href={href} className="ul-project-btn" aria-label={title}>
          <i className="flaticon-up-right-arrow" />
        </SmartLink>
      </div>
    </div>
  )
}
